// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/11/2023
 */

.DateSelect_selectionContainer__2GeCu {
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-top: 0.5rem;
}

.DateSelect_selectionContainer__2GeCu [class^="swiper-wrapper"] {
    height: auto;
}
.DateSelect_selectionContainer__2GeCu [class^="swiper-button-"]{
    width: 5px;
    color: #5A9BD8;
    top: 68%
}

.DateSelect_selectionContainer__2GeCu [class^="swiper-button-"]::after{
    font-size: 1.2rem;
    font-weight: 600;
}

.DateSelect_selectionContainer__2GeCu [class\$="-disabled"]{
    display: none;
}

.DateSelect_selectionContainer__2GeCu [class\$="-prev"]{
    left: -0.5rem !important;
}
.DateSelect_selectionContainer__2GeCu [class\$="-next"]{
    right: -0.5rem !important;
}

.DateSelect_dateContainer__K1qti {
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    align-items: center;
}

.DateSelect_dateButton__-sqL6 {
    border-radius: 100%;
    border: 1px #5A9BD8 solid;
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 0.7rem;
    margin-top: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
}

.DateSelect_dateButtonSelected__JZ89U {
    background-color: #5A9BD8;
}

/* for mobile */
@media (max-width: 770px) {
    .DateSelect_dateContainer__K1qti {
        font-size: 0.875rem;
    }
    .DateSelect_dateButton__-sqL6 {
        height: 1.25rem;
        width: 1.25rem;
        font-size: 0.875rem;
        margin: 0 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/DateSelect.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,UAAU;IACV,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,gBAAgB;IACpB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 18/11/2023\r\n */\r\n\r\n.selectionContainer {\r\n    position: relative;\r\n    width: 90%;\r\n    margin: 0 auto;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.selectionContainer [class^=\"swiper-wrapper\"] {\r\n    height: auto;\r\n}\r\n.selectionContainer [class^=\"swiper-button-\"]{\r\n    width: 5px;\r\n    color: #5A9BD8;\r\n    top: 68%\r\n}\r\n\r\n.selectionContainer [class^=\"swiper-button-\"]::after{\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.selectionContainer [class$=\"-disabled\"]{\r\n    display: none;\r\n}\r\n\r\n.selectionContainer [class$=\"-prev\"]{\r\n    left: -0.5rem !important;\r\n}\r\n.selectionContainer [class$=\"-next\"]{\r\n    right: -0.5rem !important;\r\n}\r\n\r\n.dateContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 1rem;\r\n    align-items: center;\r\n}\r\n\r\n.dateButton {\r\n    border-radius: 100%;\r\n    border: 1px #5A9BD8 solid;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    margin: 0 0.7rem;\r\n    margin-top: 0.2rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    cursor: pointer;\r\n}\r\n\r\n.dateButtonSelected {\r\n    background-color: #5A9BD8;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .dateContainer {\r\n        font-size: 0.875rem;\r\n    }\r\n    .dateButton {\r\n        height: 1.25rem;\r\n        width: 1.25rem;\r\n        font-size: 0.875rem;\r\n        margin: 0 0.5rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectionContainer": `DateSelect_selectionContainer__2GeCu`,
	"dateContainer": `DateSelect_dateContainer__K1qti`,
	"dateButton": `DateSelect_dateButton__-sqL6`,
	"dateButtonSelected": `DateSelect_dateButtonSelected__JZ89U`
};
export default ___CSS_LOADER_EXPORT___;
